<div class="main">
    <div class="breadcrumbs">
        <f-breadcrumb divider=">" [breadcrumbItems]="items" (breadcrumbSelected)="onBreadcrumbSelected($event)">
        </f-breadcrumb>
    </div>

    <h1>{{ contentTitle }}</h1>

    <!-- Your existing dashboard container -->
    <div id="dashboard-container" class="dashboard-container">
    </div>
</div>